import { useEffect } from 'react';
import { select } from '~/lib/select';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import { MediaKind, MediaPlayerStore } from './MediaPlayerStore';

const selector = (s: MediaPlayerStore) => select(s, 'loadMedia');

export function useMediaPlayer(
  mediaUrl: string | null | undefined | Array<{ src: string; type: string }>,
  mediaKind: MediaKind,
  subtitlesUrl: string | null | undefined,
  playAudio?: boolean | null,
  snapshotUrl?: string
) {
  const { loadMedia } = useMediaPlayerStore(selector);

  useEffect(() => {
    //I don't know why, but we had issue with audio component without setTimeout
    setTimeout(() => {
      loadMedia(mediaUrl, subtitlesUrl, mediaKind, playAudio, 500, snapshotUrl);
    }, 0);
  }, [mediaKind, mediaUrl, subtitlesUrl, playAudio, snapshotUrl]);
}
